
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/marketingPreferences/complete",
      function () {
        return require("private-next-pages/marketingPreferences/complete.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/marketingPreferences/complete"])
      });
    }
  